
// @ts-nocheck


export const localeCodes =  [
  "en",
  "es",
  "it",
  "fr",
  "pt",
  "pl"
]

export const localeLoaders = {
  en: [
    {
      key: "locale_en_45US_46json_2298aa34",
      load: () => import("#nuxt-i18n/2298aa34" /* webpackChunkName: "locale_en_45US_46json_2298aa34" */),
      cache: true
    }
  ],
  es: [
    {
      key: "locale_es_45ES_46json_89a0ec0c",
      load: () => import("#nuxt-i18n/89a0ec0c" /* webpackChunkName: "locale_es_45ES_46json_89a0ec0c" */),
      cache: true
    }
  ],
  it: [
    {
      key: "locale_it_45IT_46json_092cb42b",
      load: () => import("#nuxt-i18n/092cb42b" /* webpackChunkName: "locale_it_45IT_46json_092cb42b" */),
      cache: true
    }
  ],
  fr: [
    {
      key: "locale_fr_45FR_46json_14fe5c92",
      load: () => import("#nuxt-i18n/14fe5c92" /* webpackChunkName: "locale_fr_45FR_46json_14fe5c92" */),
      cache: true
    }
  ],
  pt: [
    {
      key: "locale_pt_45PT_46json_1466162e",
      load: () => import("#nuxt-i18n/1466162e" /* webpackChunkName: "locale_pt_45PT_46json_1466162e" */),
      cache: true
    }
  ],
  pl: [
    {
      key: "locale_pl_45PL_46json_2a2fdf6c",
      load: () => import("#nuxt-i18n/2a2fdf6c" /* webpackChunkName: "locale_pl_45PL_46json_2a2fdf6c" */),
      cache: true
    }
  ]
}

export const vueI18nConfigs = []

export const nuxtI18nOptions = {
  restructureDir: "i18n",
  experimental: {
    localeDetector: "",
    switchLocalePathLinkSSR: false,
    autoImportTranslationFunctions: false,
    typedPages: true,
    typedOptionsAndMessages: false,
    generatedLocaleFilePathFormat: "absolute",
    alternateLinkCanonicalQueries: false,
    hmr: true
  },
  bundle: {
    compositionOnly: true,
    runtimeOnly: false,
    fullInstall: true,
    dropMessageCompiler: false,
    optimizeTranslationDirective: false
  },
  compilation: {
    strictMessage: true,
    escapeHtml: false
  },
  customBlocks: {
    defaultSFCLang: "json",
    globalSFCScope: false
  },
  locales: [
    {
      code: "en",
      name: "English(US)",
      iso: "en",
      language: "en",
      _hreflang: "en",
      _sitemap: "en",
      files: [
        {
          path: "/codebuild/output/src3564164168/src/TVEUROPE-landing/i18n/locales/en-US.json",
          cache: undefined
        }
      ]
    },
    {
      code: "es",
      name: "Español",
      iso: "es",
      language: "es",
      _hreflang: "es",
      _sitemap: "es",
      files: [
        {
          path: "/codebuild/output/src3564164168/src/TVEUROPE-landing/i18n/locales/es-ES.json",
          cache: undefined
        }
      ]
    },
    {
      code: "it",
      name: "Italiano",
      iso: "it",
      language: "it",
      _hreflang: "it",
      _sitemap: "it",
      files: [
        {
          path: "/codebuild/output/src3564164168/src/TVEUROPE-landing/i18n/locales/it-IT.json",
          cache: undefined
        }
      ]
    },
    {
      code: "fr",
      name: "Français",
      iso: "fr",
      language: "fr",
      _hreflang: "fr",
      _sitemap: "fr",
      files: [
        {
          path: "/codebuild/output/src3564164168/src/TVEUROPE-landing/i18n/locales/fr-FR.json",
          cache: undefined
        }
      ]
    },
    {
      code: "pt",
      name: "Portuguese",
      iso: "pt",
      language: "pt",
      _hreflang: "pt",
      _sitemap: "pt",
      files: [
        {
          path: "/codebuild/output/src3564164168/src/TVEUROPE-landing/i18n/locales/pt-PT.json",
          cache: undefined
        }
      ]
    },
    {
      code: "pl",
      name: "Polski",
      iso: "pl",
      language: "pl",
      _hreflang: "pl",
      _sitemap: "pl",
      files: [
        {
          path: "/codebuild/output/src3564164168/src/TVEUROPE-landing/i18n/locales/pl-PL.json",
          cache: undefined
        }
      ]
    }
  ],
  defaultLocale: "en",
  defaultDirection: "ltr",
  routesNameSeparator: "___",
  trailingSlash: true,
  defaultLocaleRouteNameSuffix: "default",
  strategy: "prefix",
  lazy: true,
  langDir: "locales",
  rootRedirect: undefined,
  detectBrowserLanguage: {
    alwaysRedirect: false,
    cookieCrossOrigin: false,
    cookieDomain: null,
    cookieKey: "i18n_redirected",
    cookieSecure: false,
    fallbackLocale: "",
    redirectOn: "root",
    useCookie: true
  },
  differentDomains: false,
  baseUrl: "",
  customRoutes: "page",
  pages: {},
  skipSettingLocaleOnNavigate: false,
  types: "composition",
  debug: false,
  parallelPlugin: false,
  multiDomainLocales: false,
  i18nModules: []
}

export const normalizedLocales = [
  {
    code: "en",
    name: "English(US)",
    iso: "en",
    language: "en",
    _hreflang: "en",
    _sitemap: "en",
    files: [
      {
        path: "/codebuild/output/src3564164168/src/TVEUROPE-landing/i18n/locales/en-US.json",
        cache: undefined
      }
    ]
  },
  {
    code: "es",
    name: "Español",
    iso: "es",
    language: "es",
    _hreflang: "es",
    _sitemap: "es",
    files: [
      {
        path: "/codebuild/output/src3564164168/src/TVEUROPE-landing/i18n/locales/es-ES.json",
        cache: undefined
      }
    ]
  },
  {
    code: "it",
    name: "Italiano",
    iso: "it",
    language: "it",
    _hreflang: "it",
    _sitemap: "it",
    files: [
      {
        path: "/codebuild/output/src3564164168/src/TVEUROPE-landing/i18n/locales/it-IT.json",
        cache: undefined
      }
    ]
  },
  {
    code: "fr",
    name: "Français",
    iso: "fr",
    language: "fr",
    _hreflang: "fr",
    _sitemap: "fr",
    files: [
      {
        path: "/codebuild/output/src3564164168/src/TVEUROPE-landing/i18n/locales/fr-FR.json",
        cache: undefined
      }
    ]
  },
  {
    code: "pt",
    name: "Portuguese",
    iso: "pt",
    language: "pt",
    _hreflang: "pt",
    _sitemap: "pt",
    files: [
      {
        path: "/codebuild/output/src3564164168/src/TVEUROPE-landing/i18n/locales/pt-PT.json",
        cache: undefined
      }
    ]
  },
  {
    code: "pl",
    name: "Polski",
    iso: "pl",
    language: "pl",
    _hreflang: "pl",
    _sitemap: "pl",
    files: [
      {
        path: "/codebuild/output/src3564164168/src/TVEUROPE-landing/i18n/locales/pl-PL.json",
        cache: undefined
      }
    ]
  }
]

export const NUXT_I18N_MODULE_ID = "@nuxtjs/i18n"
export const parallelPlugin = false
export const isSSG = false
export const hasPages = true

export const DEFAULT_COOKIE_KEY = "i18n_redirected"
export const DEFAULT_DYNAMIC_PARAMS_KEY = "nuxtI18nInternal"
export const SWITCH_LOCALE_PATH_LINK_IDENTIFIER = "nuxt-i18n-slp"
/** client **/

/** client-end **/